import { render, staticRenderFns } from "./MailTemplates.vue?vue&type=template&id=f2ea545c&scoped=true"
import script from "./MailTemplates.vue?vue&type=script&lang=js"
export * from "./MailTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ea545c",
  null
  
)

export default component.exports